/**
 * Тема сайта. По умолчанию СВЕТЛАЯ — решение Тони 2026-09-26: «как только
 * люди заходят на сайт, у всех открывается светлая, а на тёмную пусть
 * переключаются в индивидуальном порядке». До этого дефолтом была тёмная
 * (мандат 2026-08-03).
 *
 * Выбор хранится под НОВЫМ ключом. Старый `dnai-theme` до 20.09 писался сам
 * при каждом заходе: эффект в ThemeToggle сохранял тему без всякого клика.
 * У всех, кто заходил раньше, там лежит «dark», которую они не выбирали, и
 * со старым ключом эти люди, включая самого Тони, так и видели бы тёмную.
 * Новый ключ пишется только кликом по переключателю.
 *
 * Inline-скрипт в index.html не может импортировать модуль и повторяет ключ
 * и дефолт строкой. Расхождение ловит tests/e2e/theme-toggle.spec.ts.
 */
export type Theme = 'light' | 'dark'
export const THEME_KEY = 'dnai-theme-choice'
export const LEGACY_THEME_KEY = 'dnai-theme'
export const DEFAULT_THEME: Theme = 'light'
/** Цвет адресной строки мобильного браузера под тему. */
export const THEME_COLOR: Record<Theme, string> = { light: '#FAF9F6', dark: '#0B0D11' }
